/* tslint:disable */
/* eslint-disable */
/**
 * Micro Interactions B Service
 * API for micro-interactions
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
  ApiBirthdayCake,
  ApiBirthdayCakeFromJSON,
  ApiBirthdayCakeFromJSONTyped,
  ApiBirthdayCakeToJSON,
} from './ApiBirthdayCake';
import {
  ApiBirthdayCarousel,
  ApiBirthdayCarouselFromJSON,
  ApiBirthdayCarouselFromJSONTyped,
  ApiBirthdayCarouselToJSON,
} from './ApiBirthdayCarousel';
import {
  ApiChooseOneOption,
  ApiChooseOneOptionFromJSON,
  ApiChooseOneOptionFromJSONTyped,
  ApiChooseOneOptionToJSON,
} from './ApiChooseOneOption';
import {
  ApiEvaluationV1,
  ApiEvaluationV1FromJSON,
  ApiEvaluationV1FromJSONTyped,
  ApiEvaluationV1ToJSON,
} from './ApiEvaluationV1';
import {
  ApiFlexibleV1,
  ApiFlexibleV1FromJSON,
  ApiFlexibleV1FromJSONTyped,
  ApiFlexibleV1ToJSON,
} from './ApiFlexibleV1';
import {
  ApiHideMINT,
  ApiHideMINTFromJSON,
  ApiHideMINTFromJSONTyped,
  ApiHideMINTToJSON,
} from './ApiHideMINT';
import {
  ApiNavigateToURL,
  ApiNavigateToURLFromJSON,
  ApiNavigateToURLFromJSONTyped,
  ApiNavigateToURLToJSON,
} from './ApiNavigateToURL';
import {
  ApiPetAttributeValueMapper,
  ApiPetAttributeValueMapperFromJSON,
  ApiPetAttributeValueMapperFromJSONTyped,
  ApiPetAttributeValueMapperToJSON,
} from './ApiPetAttributeValueMapper';
import {
  ApiProfilePhotoConfirmation,
  ApiProfilePhotoConfirmationFromJSON,
  ApiProfilePhotoConfirmationFromJSONTyped,
  ApiProfilePhotoConfirmationToJSON,
} from './ApiProfilePhotoConfirmation';
import {
  ApiProfilePhotoUploader,
  ApiProfilePhotoUploaderFromJSON,
  ApiProfilePhotoUploaderFromJSONTyped,
  ApiProfilePhotoUploaderToJSON,
} from './ApiProfilePhotoUploader';
import { ApiSKU, ApiSKUFromJSON, ApiSKUFromJSONTyped, ApiSKUToJSON } from './ApiSKU';
import {
  ApiSKUList,
  ApiSKUListFromJSON,
  ApiSKUListFromJSONTyped,
  ApiSKUListToJSON,
} from './ApiSKUList';
import {
  ApiSetPetAttributeValue,
  ApiSetPetAttributeValueFromJSON,
  ApiSetPetAttributeValueFromJSONTyped,
  ApiSetPetAttributeValueToJSON,
} from './ApiSetPetAttributeValue';
import {
  ApiSimpleContentCard,
  ApiSimpleContentCardFromJSON,
  ApiSimpleContentCardFromJSONTyped,
  ApiSimpleContentCardToJSON,
} from './ApiSimpleContentCard';
import {
  ApiSimpleText,
  ApiSimpleTextFromJSON,
  ApiSimpleTextFromJSONTyped,
  ApiSimpleTextToJSON,
} from './ApiSimpleText';
import {
  ApiStaticContentSnippet,
  ApiStaticContentSnippetFromJSON,
  ApiStaticContentSnippetFromJSONTyped,
  ApiStaticContentSnippetToJSON,
} from './ApiStaticContentSnippet';
import {
  ApiUpdatePetAttributeBoolean,
  ApiUpdatePetAttributeBooleanFromJSON,
  ApiUpdatePetAttributeBooleanFromJSONTyped,
  ApiUpdatePetAttributeBooleanToJSON,
} from './ApiUpdatePetAttributeBoolean';
import {
  ApiUpdatePetAttributeDate,
  ApiUpdatePetAttributeDateFromJSON,
  ApiUpdatePetAttributeDateFromJSONTyped,
  ApiUpdatePetAttributeDateToJSON,
} from './ApiUpdatePetAttributeDate';
import {
  ApiUpdatePetAttributeMultiselect,
  ApiUpdatePetAttributeMultiselectFromJSON,
  ApiUpdatePetAttributeMultiselectFromJSONTyped,
  ApiUpdatePetAttributeMultiselectToJSON,
} from './ApiUpdatePetAttributeMultiselect';
import {
  ApiUpdatePetAttributeNumber,
  ApiUpdatePetAttributeNumberFromJSON,
  ApiUpdatePetAttributeNumberFromJSONTyped,
  ApiUpdatePetAttributeNumberToJSON,
} from './ApiUpdatePetAttributeNumber';
import {
  ApiUpdatePetAttributeSingleSelect,
  ApiUpdatePetAttributeSingleSelectFromJSON,
  ApiUpdatePetAttributeSingleSelectFromJSONTyped,
  ApiUpdatePetAttributeSingleSelectToJSON,
} from './ApiUpdatePetAttributeSingleSelect';

/**
 * @type ApiMicroInteractionStepsInner
 *
 * @export
 */
export type ApiMicroInteractionStepsInner =
  | ({ type: 'BirthdayCake' } & ApiBirthdayCake)
  | ({ type: 'BirthdayCarousel' } & ApiBirthdayCarousel)
  | ({ type: 'ChooseOneOption' } & ApiChooseOneOption)
  | ({ type: 'EvaluationV1' } & ApiEvaluationV1)
  | ({ type: 'FlexibleV1' } & ApiFlexibleV1)
  | ({ type: 'HideMINT' } & ApiHideMINT)
  | ({ type: 'NavigateToURL' } & ApiNavigateToURL)
  | ({ type: 'PetAttributeValueMapper' } & ApiPetAttributeValueMapper)
  | ({ type: 'ProfilePhotoConfirmation' } & ApiProfilePhotoConfirmation)
  | ({ type: 'ProfilePhotoUploader' } & ApiProfilePhotoUploader)
  | ({ type: 'SKU' } & ApiSKU)
  | ({ type: 'SKUList' } & ApiSKUList)
  | ({ type: 'SetPetAttributeValue' } & ApiSetPetAttributeValue)
  | ({ type: 'SimpleContentCard' } & ApiSimpleContentCard)
  | ({ type: 'SimpleText' } & ApiSimpleText)
  | ({ type: 'StaticContentSnippet' } & ApiStaticContentSnippet)
  | ({ type: 'UpdatePetAttributeBoolean' } & ApiUpdatePetAttributeBoolean)
  | ({ type: 'UpdatePetAttributeDate' } & ApiUpdatePetAttributeDate)
  | ({ type: 'UpdatePetAttributeMultiselect' } & ApiUpdatePetAttributeMultiselect)
  | ({ type: 'UpdatePetAttributeNumber' } & ApiUpdatePetAttributeNumber)
  | ({ type: 'UpdatePetAttributeSingleSelect' } & ApiUpdatePetAttributeSingleSelect);

export function ApiMicroInteractionStepsInnerFromJSON(json: any): ApiMicroInteractionStepsInner {
  return ApiMicroInteractionStepsInnerFromJSONTyped(json, false);
}

export function ApiMicroInteractionStepsInnerFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ApiMicroInteractionStepsInner {
  if (json === undefined || json === null) {
    return json;
  }
  switch (json['type']) {
    case 'BirthdayCake':
      return { ...ApiBirthdayCakeFromJSONTyped(json, true), type: 'BirthdayCake' };
    case 'BirthdayCarousel':
      return { ...ApiBirthdayCarouselFromJSONTyped(json, true), type: 'BirthdayCarousel' };
    case 'ChooseOneOption':
      return { ...ApiChooseOneOptionFromJSONTyped(json, true), type: 'ChooseOneOption' };
    case 'EvaluationV1':
      return { ...ApiEvaluationV1FromJSONTyped(json, true), type: 'EvaluationV1' };
    case 'FlexibleV1':
      return { ...ApiFlexibleV1FromJSONTyped(json, true), type: 'FlexibleV1' };
    case 'HideMINT':
      return { ...ApiHideMINTFromJSONTyped(json, true), type: 'HideMINT' };
    case 'NavigateToURL':
      return { ...ApiNavigateToURLFromJSONTyped(json, true), type: 'NavigateToURL' };
    case 'PetAttributeValueMapper':
      return {
        ...ApiPetAttributeValueMapperFromJSONTyped(json, true),
        type: 'PetAttributeValueMapper',
      };
    case 'ProfilePhotoConfirmation':
      return {
        ...ApiProfilePhotoConfirmationFromJSONTyped(json, true),
        type: 'ProfilePhotoConfirmation',
      };
    case 'ProfilePhotoUploader':
      return { ...ApiProfilePhotoUploaderFromJSONTyped(json, true), type: 'ProfilePhotoUploader' };
    case 'SKU':
      return { ...ApiSKUFromJSONTyped(json, true), type: 'SKU' };
    case 'SKUList':
      return { ...ApiSKUListFromJSONTyped(json, true), type: 'SKUList' };
    case 'SetPetAttributeValue':
      return { ...ApiSetPetAttributeValueFromJSONTyped(json, true), type: 'SetPetAttributeValue' };
    case 'SimpleContentCard':
      return { ...ApiSimpleContentCardFromJSONTyped(json, true), type: 'SimpleContentCard' };
    case 'SimpleText':
      return { ...ApiSimpleTextFromJSONTyped(json, true), type: 'SimpleText' };
    case 'StaticContentSnippet':
      return { ...ApiStaticContentSnippetFromJSONTyped(json, true), type: 'StaticContentSnippet' };
    case 'UpdatePetAttributeBoolean':
      return {
        ...ApiUpdatePetAttributeBooleanFromJSONTyped(json, true),
        type: 'UpdatePetAttributeBoolean',
      };
    case 'UpdatePetAttributeDate':
      return {
        ...ApiUpdatePetAttributeDateFromJSONTyped(json, true),
        type: 'UpdatePetAttributeDate',
      };
    case 'UpdatePetAttributeMultiselect':
      return {
        ...ApiUpdatePetAttributeMultiselectFromJSONTyped(json, true),
        type: 'UpdatePetAttributeMultiselect',
      };
    case 'UpdatePetAttributeNumber':
      return {
        ...ApiUpdatePetAttributeNumberFromJSONTyped(json, true),
        type: 'UpdatePetAttributeNumber',
      };
    case 'UpdatePetAttributeSingleSelect':
      return {
        ...ApiUpdatePetAttributeSingleSelectFromJSONTyped(json, true),
        type: 'UpdatePetAttributeSingleSelect',
      };
    default:
      throw new Error(
        `No variant of ApiMicroInteractionStepsInner exists with 'type=${json['type']}'`,
      );
  }
}

export function ApiMicroInteractionStepsInnerToJSON(
  value?: ApiMicroInteractionStepsInner | null,
): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  switch (value['type']) {
    case 'BirthdayCake':
      return ApiBirthdayCakeToJSON(value);
    case 'BirthdayCarousel':
      return ApiBirthdayCarouselToJSON(value);
    case 'ChooseOneOption':
      return ApiChooseOneOptionToJSON(value);
    case 'EvaluationV1':
      return ApiEvaluationV1ToJSON(value);
    case 'FlexibleV1':
      return ApiFlexibleV1ToJSON(value);
    case 'HideMINT':
      return ApiHideMINTToJSON(value);
    case 'NavigateToURL':
      return ApiNavigateToURLToJSON(value);
    case 'PetAttributeValueMapper':
      return ApiPetAttributeValueMapperToJSON(value);
    case 'ProfilePhotoConfirmation':
      return ApiProfilePhotoConfirmationToJSON(value);
    case 'ProfilePhotoUploader':
      return ApiProfilePhotoUploaderToJSON(value);
    case 'SKU':
      return ApiSKUToJSON(value);
    case 'SKUList':
      return ApiSKUListToJSON(value);
    case 'SetPetAttributeValue':
      return ApiSetPetAttributeValueToJSON(value);
    case 'SimpleContentCard':
      return ApiSimpleContentCardToJSON(value);
    case 'SimpleText':
      return ApiSimpleTextToJSON(value);
    case 'StaticContentSnippet':
      return ApiStaticContentSnippetToJSON(value);
    case 'UpdatePetAttributeBoolean':
      return ApiUpdatePetAttributeBooleanToJSON(value);
    case 'UpdatePetAttributeDate':
      return ApiUpdatePetAttributeDateToJSON(value);
    case 'UpdatePetAttributeMultiselect':
      return ApiUpdatePetAttributeMultiselectToJSON(value);
    case 'UpdatePetAttributeNumber':
      return ApiUpdatePetAttributeNumberToJSON(value);
    case 'UpdatePetAttributeSingleSelect':
      return ApiUpdatePetAttributeSingleSelectToJSON(value);
    default:
      throw new Error(
        `No variant of ApiMicroInteractionStepsInner exists with 'type=${value['type']}'`,
      );
  }
}
